import React, { Component } from 'react';
import { formatData, AssessmentInnerContainer, valueThenSubHeaderSection, valueThenSubTextDivs } from './examUtils';
import './Exam.css'

class AssessmentHistory extends Component {
	state = {}

	render() {

		const formattedData = (formatData(this.props.data))

		const History = formattedData || {};
		const { 'Aggravating Factors': AggravatingFactors, Complaints, 'Has Diabetes': HasDiabetes, Injuries, 
			'Other Conditions List': OtherConditionsList, 'Previous Treatments': PreviousTreatments,} = History || {};
		const { Activity, ...Footwear} = History.Footwear || {};

		const orderedAggravatingFactorsKeys = ['AM Pain', 'Non Weight Bearing', 'Footwear', 'Walking', 'Running', 'Standing', 'Overnight', 'Stairs', 'Weight Bearing']
		const orderedPreviousTreatmentKeys = ['Orthotics', 'Medical Footcare', 'Compression', 'Bracing', 'OTC', 'Physiotherapy', 'Massage Therapy', 'Chiropractic', 'Other']
		const orderedCurrentFootwearKeys = ['Leisure', 'Work', 'Sport', 'Home']

		if (Object.keys(formattedData).filter(key => key !== 'Updated At' && key !== 'Photos').length === 0) {
			return (
				<div className="Exam__details-container">
					<div className="Exam__details-container-header">
						<h2>History</h2>
					</div>
					<div className="Exam__details">
						<div className="Exam__details-not-found">No History Data Found</div>
					</div>
				</div>
			)
		}

		return (
			<div className="Exam__details-container">
				<div className="Exam__details-container-header">
					<h2>History</h2>
				</div>
				{Complaints && <AssessmentInnerContainer header='Complaints'>{valueThenSubTextDivs({value: Complaints})}</AssessmentInnerContainer>}
				{AggravatingFactors && <AssessmentInnerContainer header='Aggravating Factors'>
					{orderedAggravatingFactorsKeys.map((key, i) => (
						AggravatingFactors[key] && (
							<React.Fragment key={i}>
								{valueThenSubHeaderSection(key, AggravatingFactors[key])}
							</React.Fragment>
						)
					))}
				</AssessmentInnerContainer>}
				{HasDiabetes && <AssessmentInnerContainer header='Has Diabetes'>{valueThenSubTextDivs({value: HasDiabetes})}</AssessmentInnerContainer>}
				{OtherConditionsList && <AssessmentInnerContainer header='Other Conditions'>
					{OtherConditionsList.map((item, i) => (
						<div key={i} className="Exam__details-sub-text-section">
							{valueThenSubTextDivs({value: item})}
						</div>
					))}
				</AssessmentInnerContainer>}
				{PreviousTreatments && <AssessmentInnerContainer header='Previous Treatments'>
					{orderedPreviousTreatmentKeys.map((key, i) => (
						PreviousTreatments[key] && (
							<React.Fragment key={i}>
								<h3 className="Exam__details-sub-header">{key}</h3>
								{PreviousTreatments[key].Comments && <div className="Exam__details-sub-text">{PreviousTreatments[key].Comments}</div>}
							</React.Fragment>
						)
					))}
				</AssessmentInnerContainer>}
				{Injuries && <AssessmentInnerContainer header='Injuries'>{valueThenSubTextDivs({value: Injuries})}</AssessmentInnerContainer>}
				{Activity && <AssessmentInnerContainer header='Physical Activity'>
					{Object.keys(Activity).map((key, i) => (
						<React.Fragment key={i}>
							{valueThenSubHeaderSection(key, Activity[key])}
						</React.Fragment>
					))}
				</AssessmentInnerContainer>}
				{Object.keys(Footwear).length > 0 && <AssessmentInnerContainer header='Current Footwear Assessment'>
					{orderedCurrentFootwearKeys.map((key, i) => (
						Footwear[key] && (
							<React.Fragment key={i}>
								{valueThenSubHeaderSection(key, Footwear[key])}
							</React.Fragment>
						)
					))}
				</AssessmentInnerContainer>}
			</div>
		);
	}
}
 
export default AssessmentHistory;


// WEBPACK FOOTER //
// ./src/views/Assessment/AssessmentHistory.js